/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useHeaderData = () => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allWpPage(
        filter: {
          pageType: { taxonomy: { eq: "content" } }
          filterargument: { filterargument: { eq: "header" } }
        }
      ) {
        nodes {
          id
          slug
          status
          pageType {
            taxonomy
          }
          contenttypes {
            header {
              treatments {
                treatment1
                treatment2
                treatment3
                treatment4
                treatment5
              }
              headerlabel
              staticlinks {
                link1 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link2 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link3 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link4 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link5 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link6 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link7 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
                link8 {
                  nodes {
                    ... on WpPage {
                      id
                      uri
                      title
                      pageType {
                        uri
                        name
                      }
                    }
                  }
                }
              }
              cta
              cta2
            }
            footer {
              generallinkslabel
            }
          }
          language {
            slug
          }
        }
      }
    }
  `)
  return data.allWpPage.nodes
}
